import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class StreamFilter extends ApplicationRecord {
  static jsonapiType = "stream_filters";

  @Attr() action: string;

  @Attr() scope: string;

  @Attr() streamId: number;

  @Attr() targetId: number;

  @Attr({ persist: false }) targetName: string;

  @Attr() targetType: string;
}

export default StreamFilter;
